import axios from 'axios'
import { auth } from '@/stores'
import storage from '@/plugins/storage'

// default our apiUrl for tests
const apiUrl = window.config ? window.config.apiUrl : ''
// axios global requests
axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + storage.session.getItem('auth/token')
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// axios global response
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let authData = auth();
    if (apiUrl !== '') {
      console.debug(`Error Message from interceptor (${apiUrl}): ${error.message}`, error)
    }
    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      authData.token
    ) {
      authData.clearToken();
      window.location = '/login'
    }
    return Promise.reject(error)
  }
)

// export axios common base instance (resource: https://goo.gl/sDN0IN)
export default {
  get: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.get(`${host}/${endpoint}`, data, config)
  },
  put: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.put(`${host}/${endpoint}`, data, config)
  },
  post: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.post(`${host}/${endpoint}`, data, config)
  },
  delete: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.delete(`${host}/${endpoint}`, data, config)
  }
}
